<template>
  <el-dialog title='对账调整' :visible.sync='dialogVisible' :close-on-click-modal='false'
             @close='dialogClose' width='700px'>
    <el-form :model='form' label-width='130px' label-position='right' :rules='rules'
             ref='ruleForm' class='settlement-form'>
      <el-form-item label='结算类型：' prop='type'>
        <el-input v-model='form.type' :disabled='true' size='mini' />
      </el-form-item>
      <el-form-item label='对账单标题：' prop='title'>
        <el-input v-model='form.title' :disabled='true' size='mini' />
      </el-form-item>
      <el-form-item label='税率：' prop='taxAdjustRate'>
        <el-input v-model='form.taxAdjustRate' type='number' size='mini' />
      </el-form-item>
      <el-form-item label='含税调整金额：' prop='taxAdjustPrice'>
        <el-input v-model='form.taxAdjustPrice' type='number' size='mini' />
      </el-form-item>
      <el-form-item>
        <div class='flex-center-center mt10'>
          <el-button size='medium' class='searchBtn' :loading='submitLoading' @click='submit'> 添加
          </el-button>
          <el-button size='medium' class='resetBtn' @click='dialogClose'>关闭</el-button>
        </div>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
  import { addAdjust } from '@/service/financial';

  export default {
    name: 'recordAdjustForm',
    data() {
      return {
        dialogVisible: false,
        defaultForm: {},
        form: {
          id: '',
          accountId: '',
          type: '',
          title: '',
          taxAdjustRate: '',
          taxAdjustPrice: '',
        },
        rules: {
          type: [
            {
              required: true,
              message: '请输入结算类型',
              trigger: 'blur',
            },
          ],
          title: [
            {
              required: true,
              message: '请输入对账单标题',
              trigger: 'blur',
            },
          ],
          taxAdjustRate: [
            {
              required: true,
              message: '请输入税率',
              trigger: 'blur',
            },
          ],
          taxAdjustPrice: [
            {
              required: true,
              message: '请输入含税调整金额',
              trigger: 'blur',
            },
          ],

        },
        submitLoading: false,
        type: '',
      };
    },
    mounted() {
      this.defaultForm = JSON.parse(JSON.stringify(this.form));
    },
    methods: {
      /**
       * 打开弹出框
       * @param selectTable 当前选中数据
       */
      dialogOpen(selectTable) {
        this.form = JSON.parse(JSON.stringify(this.defaultForm));
        const ids = [];
        selectTable.forEach(item => {
          ids.push(item.id);
        });
        this.form.id = ids.join(',');
        this.form.accountId = selectTable[0].accountId;
        this.form.title = selectTable[0].title;
        this.form.type = selectTable[0].typeStr;
        this.type = selectTable[0].type;
        this.dialogVisible = true;
      },
      dialogClose() {
        this.dialogVisible = false;
      },
      submit() {
        this.$refs.ruleForm.validate(async (valid) => {
          this.submitForm = {
            ...this.form,
            type: this.type,
          };
          if (valid) {
            const {
              status,
              message,
            } = await addAdjust(this.submitForm);
            if (status !== 0) return this.$message.warning(message);
            this.$message.success(message);
            this.$emit('searchBtn');
            this.dialogClose();
          }
        });
      },
    },
  };
</script>

<style lang='scss' scoped>
  .settlement-form {
    width: 70%;
    margin: 0 auto;
  }

  .settlement-tips {
    margin-top: -15px;
    position: absolute;
    right: 0;
    font-size: 12px;
    color: #F56C6C;
  }

  .el-select {
    width: 100%;
  }
</style>
